// PUT /sales-crm/filters/:id – nadpisanie zestawu filtrów

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';
import { getSalesCrmFiltersQueryKey } from 'api/endpoints/useGetSalesCrmFilters';

export interface IPutSalesCrmFiltersRequest {
  component_symbol: string;
  name?: string;
  filters: IWiseTableAdvancedFilter[];
  /** Widoczność kolumn – zapis wspólnie z filtrami. */
  column_visibility?: Record<string, boolean>;
  /** Kolejność kolumn (field_symbol) – zapis wspólnie z ustawieniami. */
  column_order?: string[];
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmFilters = (id: string | number, data: IPutSalesCrmFiltersRequest): Promise<IResponse> =>
  axios.put(`/sales-crm/filters/${id}`, data);

export const usePutSalesCrmFilters = (
  componentSymbol: string,
  options?: UseMutationOptions<IResponse, IError, { id: string | number; data: IPutSalesCrmFiltersRequest }>
) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, data }) => putSalesCrmFilters(id, data),
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries(getSalesCrmFiltersQueryKey(componentSymbol));
        options?.onSuccess?.(...args);
      }
    }
  );
};
